import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const BlogIcon = ({ color = '#8CA4C9', size = 18, ...props }) => (
  <svg
    width={size}
    viewBox="0 0 15 13"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.673 0H3.327A3.327 3.327 0 0 0 0 3.327v5.907a3.327 3.327 0 0 0 3.327 3.327h8.346A3.327 3.327 0 0 0 15 9.234V3.327A3.327 3.327 0 0 0 11.673 0zm.538 9.88a.538.538 0 0 1-.538.539H3.325a.539.539 0 0 1-.536-.539v-.6c0-.297.24-.538.538-.538h8.348c.296 0 .536.242.536.539v.6zm0-3.3a.538.538 0 0 1-.538.539H3.325a.539.539 0 0 1-.536-.539v-.6c0-.297.24-.538.538-.538h8.348c.296 0 .536.242.536.539v.6zm0-3.388c0 .297-.24.538-.536.539h-8.35a.538.538 0 0 1-.538-.539v-.6c0-.297.241-.539.538-.539h8.35c.297 0 .538.242.538.539v.6h-.002z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

BlogIcon.propTypes = propTypes;

export default BlogIcon;
